import React from 'react';
import './PrivacyPolicy.css';

function NotFound() {
  return <div className="privacy-policy"><h2>Page Not Found</h2></div>;
}

export default NotFound;
